/**
 * 路由配置
 */

import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

/**
 * 路由配置
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/experience/diagnosis'
  },
  {
    path: '/experience/diagnosis',
    name: 'ExperienceDiagnosis',
    component: () => import('@/views/ExperienceDiagnosisView.vue'),
    meta: {
      title: '体验舌诊 - 健康小屋',
      requiresAuth: false
    }
  },
  {
    path: '/experience/result/:code',
    name: 'ExperienceResult',
    component: () => import('@/views/ExperienceResultView.vue'),
    meta: {
      title: '诊断结果 - 健康小屋',
      requiresAuth: false
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: {
      title: '页面不存在'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

/**
 * 创建路由实例
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

/**
 * 全局前置守卫
 */
router.beforeEach((to, from, next) => {
  try {
    // 设置页面标题
    if (to.meta?.title) {
      document.title = to.meta.title as string
    }

    console.log(`🚦 路由跳转: ${from.path} -> ${to.path}`)
    next()
  } catch (error) {
    console.error('路由守卫错误:', error)
    next('/404')
  }
})

/**
 * 全局后置钩子
 */
router.afterEach((to, from, failure) => {
  if (failure) {
    console.error('路由跳转失败:', failure)
  } else {
    console.log(`✅ 路由跳转完成: ${to.path}`)
  }
})

export default router


